import { ApiMethod } from '@wajeez-web/stores/base';
import { Server, contentClient } from '@wajeez-web/core/api-base';
import { AlertType, CommonActions } from '@wajeez-web/stores/common';
import { thunkErrorHandler } from '@wajeez-web/core/utils';

export const getQuestionsAsDataTable: ApiMethod<
  Server.QuestionDatatableInput,
  Server.TableOfQuestionColumns,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_Questions_Client(
        undefined,
        contentClient
      );

      const response =
        await client.admin_Questions_datatable_byContentEntityId_post_V1(data);

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const getQuestionsByQuizId: ApiMethod<
  number,
  Server.QuestionDashboardOutput[],
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Questions_Client(undefined, contentClient);

    const response = await client.admin_Questions_lookups_byQuizId_get_V1(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        for: 'modal',
        type: AlertType.WARNING,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(error);
  }
};

export const createNewQuestion: ApiMethod<
  Server.AddQuestionByContentEntityIdInput,
  number,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Questions_Client(undefined, contentClient);

    const response = await client.admin_Questions_add_post_V2(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        for: 'modal',
        type: AlertType.WARNING,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(error);
  }
};

export const editQuestion: ApiMethod<
  Server.EditQuestionInput,
  void,
  any
> = async (variables, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Questions_Client(undefined, contentClient);

    const response = await client.admin_Questions_edit_put_V1(variables);

    if (response.success) {
      return;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        for: 'modal',
        type: AlertType.WARNING,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(error);
  }
};

export const deleteQuestion: ApiMethod<number, void, any> = async (
  variables,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Questions_Client(undefined, contentClient);

    const response = await client.admin_Questions_delete_delete_V1(variables);

    if (response.success) {
      return;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        for: 'modal',
        type: AlertType.WARNING,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(error);
  }
};

export const changeQuestionPublishState: ApiMethod<
  Server.QuestionPublicationInput,
  void,
  any
> = async (variables, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Questions_Client(undefined, contentClient);

    const response = await client.admin_Questions_publish_state_put_V1(
      variables
    );

    if (response.success) {
      return;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        for: 'page',
        type: AlertType.WARNING,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(error);
  }
};

export const orderQuestions: ApiMethod<
  Server.EditQuestionsOrderInput,
  void,
  any
> = async (variables, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Questions_Client(undefined, contentClient);

    const response = await client.admin_Questions_edit_order_put_V1(variables);

    if (response.success) {
      return;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        for: 'modal',
        type: AlertType.WARNING,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(error);
  }
};
